import gql from 'graphql-tag'

export const closeDeal = gql`
  mutation closeDeal($idDeal: Int!, $idClosingReason: Int!) {
    close_won_lead(idDeal: $idDeal, idClosingReason: $idClosingReason) {
      id
    }
  }
`
